<template>
  <div class="method-box">
    <base-checkbox v-if="isNew" :label="label" v-model="value" />
    <p v-else class="method-name">{{ label }}</p>
    <p class="preview">PRÉ-VISUALIZAR</p>
  </div>
</template>
<script>
import BaseCheckbox from "@/components/Checkbox";

export default {
  data() {
    return {
      value: false,
    };
  },
  props: {
    label: { type: String, required: true },
    isNew: { type: Boolean, default: true },
    checked: {},
  },
  components: {
    BaseCheckbox,
  },
  created() {
    this.value = this.checked || this.checked === "true";
    console.log(this.value);
  },
  watch: {
    value(value) {
      this.$emit("setValue", value);
    },
  },
};
</script>
<style scoped>
.method-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 0px;
  border-top: 1px solid #dfdfdf;
}

.method-box:last-child {
  border-bottom: 1px solid #dfdfdf;
}

.preview {
  font-size: 1.4em;
  font-weight: 600;
  color: var(--default);
  cursor: pointer;
}

.method-name {
  font-size: 1.6em;
  color: #888;
}
</style>